import React, { useState, useEffect, useRef } from "react";
import { Select, TextInput } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";

const formInputContainerStyle = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: 8,
  alignItems: "center",
  margin: "24px 48px 24px 0px",
};

const labelStyle = {
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "24px",
  color: "var(--sl-text-primary)",
  whiteSpace: "nowrap",
};

const toOptions = (values) => (values || []).map((value) => ({ value, label: value }));

export default () => {
  const {
    selectedNodeFormState,
    setSelectedNodeFormState,
  } = useCustomCampaignShowContext();

  const mountedRef = useRef(false);

  const [timeUnits, setTimeUnits] = useState(0);

  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }

    const debounceUpdateTimeUnits = _.debounce(() => {
      setSelectedNodeFormState({
        ...selectedNodeFormState,
        node_data: {
          ...selectedNodeFormState.node_data,
          time_units: timeUnits,
        },
      });
    }, 500);

    debounceUpdateTimeUnits();

    return () => {
      debounceUpdateTimeUnits.cancel();
    };
  }, [timeUnits]);

  useEffect(() => {
    setTimeUnits(selectedNodeFormState?.node_data?.time_units || 0);
  }, [selectedNodeFormState]);

  const updateNodeData = (key) => (value) => value !== selectedNodeFormState?.node_data?.[key] && setSelectedNodeFormState({
    ...selectedNodeFormState,
    node_data: {
      ...selectedNodeFormState.node_data,
      [key]: value,
    },
  });

  const nodeData = selectedNodeFormState?.node_data;
  const nodeDataOptions = selectedNodeFormState?.node_data_options;

  return (
    <>
      <div style={formInputContainerStyle}>
        <div style={labelStyle}>Wait until...</div>
        <div style={{ width: 88 }}>
          <TextInput
            aria-label="Time units"
            inputMode="numeric"
            value={String(timeUnits)}
            placeholder="0"
            onChange={(e) => {
              const digits = e.target.value.replace(/\D/g, "");
              if (digits.length > 5) return;
              setTimeUnits(parseInt(digits || "0", 10));
            }}
            onFocus={(e) => e.target.select()}
          />
        </div>
        <Select
          aria-label="Time unit"
          width={120}
          options={toOptions(nodeDataOptions?.time_unit)}
          value={nodeData?.time_unit ?? null}
          onChange={updateNodeData("time_unit")}
        />
      </div>
      <div style={formInputContainerStyle}>
        <Select
          aria-label="Before or after"
          width={120}
          options={toOptions(nodeDataOptions?.time_offset)}
          value={nodeData?.time_offset ?? null}
          onChange={updateNodeData("time_offset")}
        />
        <Select
          aria-label="Event milestone"
          width={220}
          options={toOptions(nodeDataOptions?.wait_until_event)}
          value={nodeData?.wait_until_event ?? null}
          onChange={updateNodeData("wait_until_event")}
        />
      </div>
    </>
  );
};
